import {Dispatch} from 'redux';
import {sportEventLiveDataById} from '../../../API/sportEvents';
import {beMatchLiveDataToMatchLiveData} from '../../../API/utils';
import {
  MATCH_LIVE_DATA_BY_ID_GET_REQUEST,
  MATCH_LIVE_DATA_BY_ID_GET_RESPONSE,
  MATCH_LIVE_DATA_BY_ID_GET_INVALIDATE,
} from '../../actionTypes';
import {
  MatchLiveDataByIdGetInvalidateAction,
  MatchLiveDataByIdGetRequestAction,
  MatchLiveDataByIdGetResponseAction,
} from '../types';
import {MatchLiveData} from '../../../utils/types';
import standardizeError from '../../../utils/standardizeError';

/**
 * Action creator for the get request of the single match info request (by id)
 * @param id
 */
const getMatchLiveDataByIdGetRequest = (id: string): MatchLiveDataByIdGetRequestAction => ({
  type: MATCH_LIVE_DATA_BY_ID_GET_REQUEST,
  payload: id,
});

/**
 * Action creator for the get response of the single match info request (by id)
 */
const getMatchLiveDataByIdGetResponse = (
  matchLiveData: MatchLiveData
): MatchLiveDataByIdGetResponseAction => ({
  type: MATCH_LIVE_DATA_BY_ID_GET_RESPONSE,
  payload: {matchLiveData},
});

/**
 * Action creator for the get invalidation of the single match info request (by id)
 * @param error
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getMatchLiveDataByIdGetInvalidate = (error: Error): MatchLiveDataByIdGetInvalidateAction => ({
  type: MATCH_LIVE_DATA_BY_ID_GET_INVALIDATE,
  error: standardizeError(error),
});

/**
 * // TODO: document
 */
const getMatchLiveDataById = (id: string) => (dispatch: Dispatch): Promise<any> => {
  dispatch(getMatchLiveDataByIdGetRequest(id));

  return sportEventLiveDataById(id)
    .then(beMatchLiveDataToMatchLiveData)
    .then((matchLiveData: MatchLiveData) =>
      dispatch(getMatchLiveDataByIdGetResponse(matchLiveData))
    )
    .catch((error: Error) => dispatch(getMatchLiveDataByIdGetInvalidate(error)));
};

export default getMatchLiveDataById;
